module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_7005.51fb556f.png";